
import { useState, useEffect } from "react";
import { supabase } from "@/lib/supabase";

export function useValidatedCoursePrice(courseId: string | null, coursePrice: number) {
  const [validatedPrice, setValidatedPrice] = useState<number | null>(null);

  useEffect(() => {
    const validatePrice = async () => {
      const parsedPrice = parseFloat(String(coursePrice));
      if (!isNaN(parsedPrice) && parsedPrice > 0) {
        setValidatedPrice(parsedPrice);
        return;
      }
      if (courseId) {
        try {
          const { data, error } = await supabase
            .from('courses')
            .select('price')
            .eq('id', courseId)
            .single();

          if (!error && data && typeof data.price === 'number' && data.price > 0) {
            setValidatedPrice(data.price);
            return;
          }
        } catch {
          // ignore; handled below
        }
      }
      setValidatedPrice(null);
    };

    validatePrice();
  }, [courseId, coursePrice]);

  const isPriceValid = validatedPrice !== null && validatedPrice > 0;
  const formattedPrice = isPriceValid ? validatedPrice!.toFixed(2) : "0.00";
  return { validatedPrice, isPriceValid, formattedPrice };
}
